/* istanbul ignore file */
import { XMLParser } from 'fast-xml-parser'
import { useCallback, useState } from 'react'

export const useParseFile = () => {
  const [parsedFile, setParsedFile] = useState(null)
  const [parsedError, setParsedError] = useState(false)

  const SUPPORTED_PARSED_FILES = Object.freeze({
    XML: 'xml',
  })

  const parseXmlFile = useCallback((file) => {
    try {
      const options = {
        ignoreAttributes: false
      }
      const parser = new XMLParser(options)
      const jsonObj = parser.parse(file)

      setParsedFile(jsonObj)
      return jsonObj
    }
    catch (error: any) {
      setParsedError(error.message)
    }
  }, [])

  const parseFile = useCallback((file, type) => {
    switch (type) {
      case SUPPORTED_PARSED_FILES.XML:
        return parseXmlFile(file)
      default:
        throw new Error('invalid file type')
    }
  }
  , [parseXmlFile, SUPPORTED_PARSED_FILES])

  return {
    parseFile,
    parsedFile,
    parsedError,
    setParsedError
  }
}
